<img 
  alt=""
  *ngIf="src"
  [src]="src"
  [alt]="icon"
  [style.width]="size + 'px'" [style.height]="size + 'px'"
  [class.rotatable]="rotatable !== null"
  [style.transform]="'rotate(' + rotate + 'deg)'"
>
